import { render, staticRenderFns } from "./commonAside.vue?vue&type=template&id=2e021dea&scoped=true&"
import script from "./commonAside.vue?vue&type=script&lang=js&"
export * from "./commonAside.vue?vue&type=script&lang=js&"
import style0 from "./commonAside.vue?vue&type=style&index=0&id=2e021dea&lang=stylus&scoped=true&"
import style1 from "./commonAside.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e021dea",
  null
  
)

export default component.exports